import * as React from "react";
import Box from "@mui/material/Box";
import {useContext, useEffect, useState} from "react";
import {TokenContext} from "../../Context/TokenContext";
import {
    Card,
    CardContent,
    Dialog,
    Alert,
    AlertTitle,
    CircularProgress
} from "@mui/material";
import Typography from "@mui/material/Typography";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";

export function Authentication() {
    const {
        isAuthenticated,
        isLoading,
        authError,
        finishProcess,
        startOAuthFlow,
        setCode,
        clearAuth
    } = useContext(TokenContext);

    const navigate = useNavigate();
    const [hasProcessed, setHasProcessed] = useState(false);

    useEffect(() => {
        if (isAuthenticated && finishProcess) return;
        if (hasProcessed) return;

        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        const error = params.get('error');

        if (error) {
            setHasProcessed(true);
            return;
        }

        if (code) {
            setCode(code, state);
            setHasProcessed(true);
            window.history.replaceState({}, document.title, window.location.pathname);
            return;
        }

        if (!isAuthenticated) {
            const timer = setTimeout(() => startOAuthFlow(), 1000);
            return () => clearTimeout(timer);
        }
    }, [hasProcessed, setCode, startOAuthFlow, isAuthenticated, finishProcess]);

    useEffect(() => {
        if (isAuthenticated && finishProcess) {
            const timer = setTimeout(() => navigate('/', {replace: true}), 1000);
            return () => clearTimeout(timer);
        }
    }, [isAuthenticated, finishProcess, navigate]);

    const handleRetry = () => {
        clearAuth();
        setHasProcessed(false);
        startOAuthFlow();
    };

    return (
        <Box width={'100vw'} height={'100vh'} sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #FF7233 0%, #B23A0F 100%)'
        }}>
            <Dialog open={true} fullWidth={true} maxWidth={'sm'} disableEscapeKeyDown>
                <Card>
                    <CardContent sx={{p: 4}}>
                        {authError && (
                            <Alert severity="error" sx={{mb: 3}}>
                                <AlertTitle>Erreur de connexion</AlertTitle>
                                {authError}
                            </Alert>
                        )}

                        {isAuthenticated && finishProcess ? (
                            <Box textAlign="center">
                                <Typography variant="h5" gutterBottom color="success.main">
                                    Connexion réussie
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Redirection...
                                </Typography>
                                <CircularProgress size={24} sx={{mt: 2}}/>
                            </Box>
                        ) : isLoading ? (
                            <Box textAlign="center">
                                <Typography variant="h5" gutterBottom>
                                    Vérification de la connexion
                                </Typography>
                                <CircularProgress sx={{mt: 2}}/>
                            </Box>
                        ) : !hasProcessed && !authError ? (
                            <Box textAlign="center">
                                <Typography variant="h5" gutterBottom>
                                    Redirection vers la connexion
                                </Typography>
                                <CircularProgress sx={{mt: 2}}/>
                            </Box>
                        ) : null}
                    </CardContent>

                    {authError && (
                        <CardActions sx={{justifyContent: 'flex-end', p: 2}}>
                            <Button onClick={handleRetry} variant="contained" color="primary">
                                Réessayer
                            </Button>
                        </CardActions>
                    )}
                </Card>
            </Dialog>
        </Box>
    );
}
